import React, { useEffect, useState } from 'react'
import { Routes, Route } from "react-router-dom";
import SignIn from './SignIn';
import Signup from './Signup';
import './Auth.scss'
import ForgetPassword from './ForgetPassword';
import NotFoundPage from '../Components/NotFoundPage';
import ValidateOtp from './ValidateOtp';

function Index() {
    const [isCollapsed, setIsCollapsed] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsCollapsed(false);
        }, 1000); // Show splash for 3 seconds

        return () => clearTimeout(timer);
    }, []);

    const isOtpAllowed = () => {
        const otpFlow = sessionStorage.getItem("is_otp_allowed");
        // 'signup' or 'forgot'
        return otpFlow === "signup" || otpFlow === "forgot" || otpFlow === "/";
    };


    const getRedirectPath = () => {
        const sourcePage = sessionStorage.getItem("otp_source_page");
        if (sourcePage === "/sign-up") return "/sign-up";
        if (sourcePage === "/forget-password") return "/forget-password";
        return "/";
    };
    // const isOtpAllowed = () => sessionStorage.getItem('is_otp_allowed') === 'true';
    return (
        <div className='sign-in-container'>
            {isCollapsed ?
                <div
                    className="logo-panel"
                >
                    <img
                        src="https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/splash-logo.svg"
                        alt="Logo"
                    />
                </div> :
                <div
                    className="auth-panel"
                >
                    <Routes>
                        <Route index element={<SignIn />} />
                        <Route path="/sign-up" element={<Signup />} />
                        <Route path="/forget-password" element={<ForgetPassword />} />
                        <Route
                            path="/otp-verification"
                            element={
                                <ValidateOtp />
                            }
                        />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>

                </div>
            }
        </div>
    )
}

export default Index;